import React from 'react';
import { withRouter } from 'react-router-dom';
// ANTD
import Menu from 'antd/lib/menu';
import Modal from 'antd/lib/modal';
import Dropdown from 'antd/lib/dropdown';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import notification from 'antd/lib/notification';
// APOLLO
import { graphql, compose } from 'react-apollo';
import deleteQuestionTemplate from 'ApolloClient/Mutations/deleteQuestionTemplate';
import questionTemplatesQuery from 'ApolloClient/Queries/questionTemplates';
import saveQuestionTemplate from 'ApolloClient/Mutations/saveQuestionTemplate';
import QuestionTemplateForm from 'components/forms/QuestionTemplateForm';
import questionsQuery from 'ApolloClient/Queries/questions';
// LIB
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

const ICON_STYLE = { marginRight: 6, fontSize: 17 };

const confirm = Modal.confirm;

export class ActionMenu extends React.PureComponent {
  state = {
    loading: false,
    showEditModal: false,
    step: 1,
    
  };
  
  showConfirm() {
    confirm({
      title: 'Do you Want to delete this item?',
      content: 'Some descriptions',
      onOk() {
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  showDeleteConfirm() {
    confirm({
      title: 'Are you sure you want to delete this question template?',
      content: `Once it's gone, it's gone.`,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: this.onDelete,
      onCancel: () => console.log('Cancel'),
    });
  }
  onSuccessful = ({ message }) => {
    if (message) {
      notification.success({ message });
    }
    // set a timeout so things look butter smooth and people have time to see the notification
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  updateAfterDelete = (proxy, { data }) => {
        
    // will update local apollo cache after the mutation. see apollo docs.
        const localData = proxy.readQuery({
          query: questionTemplatesQuery,
          variables: {
            params: null
          }
        });

        // filter out the client we just deleted form the local apollo cache
        let newData = localData.questionTemplates.filter(item => item._id !== this.props.record._id);
        // overwrite the apollo cache with filtered array

        proxy.writeQuery({
          query: questionTemplatesQuery,
          variables: {
            params: null
          },
          data: {
            ...localData.questionTemplates,
            questionTemplates: newData,
          },
        });

  };

  onDelete = async () => {
    const { record } = this.props; // destructure
    const variables = { _id: record._id };
    const refetchQueries = [
      {
        query: questionTemplatesQuery,
        variables: {},
      },
    ];

    this.setState({ loading: true }); // start loader

    try {
      await this.props.deleteQuestionTemplate({ variables, refetchQueries, update: this.updateAfterDelete });
    } catch (err) {
      return ErrorHelpers.handelGraphqlError(err);
    }

    this.onSuccessful({
      message: `Question successfully deleted!`,
    });
  };

  handleShowEditModal = () => {
    this.setState({ 
      showEditModal: true, 
      record: {
        ...this.props.record,
        selectedQuestions: this.props.record.questions.map(item => ({ value: item, label: item }))
    }});
  }

  handleMenuClick = ({ key }) => {
    switch (key) {
      case '1':
        return this.showDeleteConfirm();
      case 'edit':
        return this.handleShowEditModal();
      default:
        return null;
    }
  };

  onNext = () => {
    this.setState({ step: 2 });
  };

  onCancel = () => {
    this.onClear();
  };

  onClear = () => {
    this.setState({
      showEditModal: false,
      step: 1,
      loading: false,
      record: null,
    });
  };

  onSubmit = () => {
    if (this.state.loading) {
      return null;
    }

    if (this.state.step === 1) {
      return this.setState({ step: 2, loading: false });
    }

    if (this.state.record.selectedQuestions.length === 0) {
      return message.error('must select at least one question');
    }

    if (this.state.step === 2 && this.state.record.selectedQuestions.length > 0) {
      this.setState({ loading: true });
      let params = {
        title: this.state.record.title,
        questions: this.state.record.selectedQuestions.map(q => q.value),
      };

      this.props
        .saveQuestionTemplate({
          variables: { _id: this.props.record._id, params },
          refetchQueries: [{ query: questionTemplatesQuery }],
        })
        .then(res => this.onClear())
        .catch(err => this.onClear());
    }

  }

  render() {
    
    return (
      <div style={s.container}>
        <Dropdown
          trigger={['click']}
          overlay={
            <Menu onClick={this.handleMenuClick}>
              <Menu.Item key="1">
                <Icon type="delete" style={ICON_STYLE} />
                Delete Template
              </Menu.Item>
              <Menu.Item key="edit">
                <Icon type="edit" style={ICON_STYLE} />
                  Edit Template
              </Menu.Item>
            </Menu>
          }
        >
          {this.state.loading ? (
            <Icon type="loading" style={s.loadingIcon} />
          ) : (
            <Icon type="ellipsis" style={{ fontSize: 20, fontWeight: 600 }} />
          )}
        </Dropdown>
        <Modal okText={this.state.step === 1 ? 'Next' : 'Save'} onOk={this.onSubmit} title="Edit Template" visible={this.state.showEditModal} onCancel={() => this.setState({ showEditModal: false, step: 1 })}>
          {this.state.record && (
            <QuestionTemplateForm
              step={this.state.step}
              title={this.state.record.title}
              questionOptions={this.props.questionsQuery.questions}
              selectedQuestions={this.state.record.selectedQuestions}
              onChange={(value) => this.setState({
                record: {
                  ...this.state.record,
                  ...value
                }
              })}
              loadingQuestions={this.props.questionsQuery.loading}
            />
          )}
        </Modal>
      </div>
    );
  }
}

const s = {
  loadingIcon: {
    fontSize: 20,
    color: '#f29980',
    fontWeight: 600,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuItem: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
};


// EXPORT
// ==========================================

export default compose(
  graphql(deleteQuestionTemplate, { name: 'deleteQuestionTemplate' }),
  graphql(saveQuestionTemplate, { name: 'saveQuestionTemplate' }),
  graphql(questionsQuery, { name: 'questionsQuery' }),
)(withRouter(ActionMenu));



// WEBPACK FOOTER //
// ./src/routes/app-studio/QuestionTemplatesArea/QuestionTemplatesTable/ActionMenu/index.js